import { format, formatDistanceToNow, parseISO } from 'date-fns'

const currencyFormatters = new Map<string, Intl.NumberFormat>()

export function formatCurrency(amount: number, currency: string) {
  let formatter = currencyFormatters.get(currency)
  if (!formatter) {
    formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency })
    currencyFormatters.set(currency, formatter)
  }
  return formatter.format(amount)
}

export function formatDate(iso: string) {
  return format(parseISO(iso), 'MMM d, yyyy')
}

export function formatDateTime(iso: string) {
  return format(parseISO(iso), 'MMM d, yyyy · h:mm a')
}

export function formatRelative(iso: string) {
  return formatDistanceToNow(parseISO(iso), { addSuffix: true })
}
const sizeUnits = ['B', 'KB', 'MB', 'GB'] as const

/** 1536 → "1.5 KB". */
export function formatFileSize(bytes: number) {
  let value = bytes
  let unit = 0
  while (value >= 1024 && unit < sizeUnits.length - 1) {
    value /= 1024
    unit++
  }
  return `${value < 10 && unit > 0 ? value.toFixed(1) : Math.round(value)} ${sizeUnits[unit]}`
}
